import { render, staticRenderFns } from "./SearchChell.vue?vue&type=template&id=27ffe3bc"
import script from "./SearchChell.vue?vue&type=script&lang=js"
export * from "./SearchChell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports